import { Application } from "@hotwired/stimulus"

const application = window.Stimulus || Application.start()

window.Stimulus = application

export default application
